module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="fmcy-order-item-inner">\n  <div class="fmcy-order-item-code">\n    ';
 if (is_clickable == true) { 
__p+='\n      <a href="'+
((__t=(order_details_url))==null?'':__t)+
'">'+
((__t=( notification_message ))==null?'':__t)+
'</a>\n    ';
 } else { 
__p+='\n      '+
((__t=( notification_message ))==null?'':__t)+
'\n    ';
 } 
__p+='\n  </div>\n</div>\n<div class="fmcy-order-item-edit-bar">\n  <div class="fmcy-order-item-btn-change-region"></div>\n  <div class="fmcy-order-item-btn-cancel-region"></div>\n</div>\n<div class="fmcy-order-item-btn-edit-region"></div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/orders/order-item/order-item.html
 ** module id = 448
 ** module chunks = 1 85 103 110 125
 **/